import axios from 'axios'
import { BASE_URL } from '../ApiService/ApiConfig.js';

let token = localStorage.getItem('jwt');
if (token) {
    token = token.replaceAll('"', '');
}

let config = {
    headers: {
        'Content-Type': "application/json",
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'Authorization': 'Bearer ' + token
    }

}


export class UsuarioService {

    async getUsuario(username) {

        return await axios.get(`${BASE_URL}/usuario/${username}`,
            config
        ).then(res => res.data.data);
    }

    async getusuarioPorId(usuarioId) {
        return await axios.get(`${BASE_URL}/usuario/id/${usuarioId}`,
            config
        ).then(res => res.data.data);
    }
}
